import styles from './tables.module.css';
import ArrowGreen from '../../../images/arrow-product-green-right.svg';
import { NavLink } from 'react-router-dom';
import { useActiveButton } from '../../../services/context/ActiveButtonContext';

function SubButtonLinks({ data }) {
  const val = useActiveButton();
  return (
    <div className={styles.buttonWrapper}>
      <NavLink to={'/info/glossarij-investora'} className={styles.subButton}>
        <div className={styles.buttonTxt}>Глоссарий инвестора</div>
        <img alt='arrow' src={ArrowGreen} className={styles.arrowGreenImg} />
      </NavLink>
      <NavLink to={`/info/${data[0]?.instructions?.slug}`} className={styles.subButton}>
        <div className={styles.buttonTxt}>{data[0]?.instructions?.title}</div>
        <img alt='arrow' src={ArrowGreen} className={styles.arrowGreenImg} />
      </NavLink>
    </div>
  );
}

export default SubButtonLinks;
